import { ReactComponent as ClineIcon } from 'Images/cline.svg';

import { PLACEHOLDER } from './placeholders';
import buildHeaderLines from './headers';
import {
  AUTH_TOKEN,
  AUTH_USER_PASSWORD,
  BLOCK_FILE,
  BLOCK_INSTRUCTIONS,
  CLIENT_STATUS_SUPPORTED
} from './constants';

const buildConfig = (authMethod) => `{
  "mcpServers": {
    "faraday": {
      "type": "streamableHttp",
      "url": "${PLACEHOLDER.serverUrl}",
      "headers": {
${buildHeaderLines(authMethod, '        ', ': ')}
      }
    }
  }
}`;

const cline = {
  id: 'cline',
  label: 'Cline',
  icon: ClineIcon,
  status: CLIENT_STATUS_SUPPORTED,
  authMethods: [AUTH_TOKEN, AUTH_USER_PASSWORD],
  summaryId: 'mcp.client.cline.summary',
  buildSections: ({ authMethod }) => [
    {
      id: 'open-settings',
      titleId: 'mcp.client.cline.open.title',
      blocks: [
        {
          id: 'open-steps',
          type: BLOCK_INSTRUCTIONS,
          items: [
            { id: 'panel', textId: 'mcp.client.cline.open.panel' },
            { id: 'configure', textId: 'mcp.client.cline.open.configure' }
          ]
        }
      ]
    },
    {
      id: 'config',
      titleId: 'mcp.client.cline.config.title',
      blocks: [
        {
          id: 'config-file',
          type: BLOCK_FILE,
          captionId: 'mcp.client.cline.config.caption',
          snippet: buildConfig(authMethod)
        }
      ]
    }
  ]
};

export default cline;
